/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Snap_To_Shot_Changes_HelpInputs */

const en_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically snap to shot changes when updating Timeline Events.`)
};

const fr_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner automatiquement sur les changements de plan lors de la mise à jour des événements de la timeline.`)
};

const de_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Anpassung an Szenenänderungen beim Aktualisieren von Zeitleistenereignissen.`)
};

const it_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia automaticamente alle modifiche di ripresa durante l'aggiornamento degli eventi della cronologia.`)
};

const ru_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая привязка к изменениям кадров при обновлении событий на временной шкале.`)
};

const es_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar automáticamente los cambios de toma al actualizar los eventos de la línea de tiempo.`)
};

const zh_cn2_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新时间线事件时，自动捕捉镜头变化。`)
};

const ja_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムライン イベントを更新するときに、ショットの変更に自動的にスナップします。`)
};

const hi_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन इवेंट्स को अपडेट करते समय शॉट में हुए बदलावों को स्वचालित रूप से स्नैप करें।`)
};

const pt_pt2_options_editor_snap_to_shot_changes_help = /** @type {(inputs: Options_Editor_Snap_To_Shot_Changes_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste automático às mudanças de cena ao atualizar os eventos da linha do tempo.`)
};

/**
* | output |
* | --- |
* | "Automatically snap to shot changes when updating Timeline Events." |
*
* @param {Options_Editor_Snap_To_Shot_Changes_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_snap_to_shot_changes_help = /** @type {((inputs?: Options_Editor_Snap_To_Shot_Changes_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Snap_To_Shot_Changes_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "de") return de_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "it") return it_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "ru") return ru_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "es") return es_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "ja") return ja_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "hi") return hi_options_editor_snap_to_shot_changes_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_snap_to_shot_changes_help(inputs)
	return en_options_editor_snap_to_shot_changes_help(inputs)
});